import React from 'react'

import { useListenUserProfileQuery } from 'modules/Users/userApi'
import { useAuth } from 'modules/Auth/hooks/useAuth'
import ModerationTab from './components/ModerationTab'

// Community's second page, reached from the Community menu in the header,
// which is also the way back to the feed.
function Moderation() {
  const { userId } = useAuth()
  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''

  return (
    <div className='flex flex-col min-h-screen bg-offWhite px-16'>
      <div className='w-full max-w-[640px] mx-auto mt-12'>
        <div className='mb-8'>
          <h1 className='font-bold text-5xl text-tBlack'>Moderation</h1>
          <p className='text-gray-500 mt-4'>Reports filed by members, and who is banned from the community.</p>
        </div>

        <ModerationTab coachOrgId={coachOrgId} />
      </div>
    </div>
  )
}

export default Moderation
